import React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import { TableContainer, Toolbar, Typography, IconButton, Modal, TableRow, TableCell, Radio, } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Paper from "@mui/material/Paper";
import CommonTable from "./CommonTable";
import CommonDropDwn from "./CommonDropDwn";
import CommonDropFamily from "./CommonDropFamily";
// const rows = [
//   {
//     planInfo: "Elite1",
//     EnrollFee: "$100",
//     cost: "$200",
//   },
//   {
//     planInfo: "Elite2",
//     EnrollFee: "$100",
//     cost: "$200",
//   },
// ];
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&.MuiTableRow-root.Mui-selected": {
        backgroundColor: "#00c389",
        color: "#fff",
    },
    "&.Mui-selected td span.cost-per-month": {
        color: "#fff",
    },
    "&.Mui-selected td span.details-button": {
        color: "#201547",
    },
    "&.MuiTableRow-root.Mui-selected.radio-buttons": {
        color: "#162242",
    },
}));
const StyledRadio = styled(Radio)(({ theme }) => ({
    "&.MuiRadio-root": {
        backgroundColor: "transparent !important",
    },
}));
export const EnrolmentSelectPlan = (props) => {
    const [selected, setSelected] = React.useState(0);
    const [data, setData] = React.useState(props.data);
    const [listOfCost, setListOfCost] = React.useState([]);
    const [listOfEnrollCost, setListOfEnrollCost] = React.useState([]);
    const [selectedFamily, setSelectedFamily] = React.useState(props.data[0].categoryAmountList[0].category);
    React.useEffect(() => {
        setData(props.data);
        let listCost = [];
        props.data.map((res) => {
            listCost.push(res.categoryAmountList[0].amount);
        });
        setListOfCost(listCost);
        if (props.enrollFeeFlag) {
            let listEnrollCost = [];
            props.data.map((res) => {
                listEnrollCost.push(res.enrollmentFeesList[0].amount);
            });
            setListOfEnrollCost(listEnrollCost);
        }
    }, []);
    React.useEffect(() => {
        let DataSelected = {
            planId: data[selected].planId,
            enrollmentFees: listOfEnrollCost[selected],
            categoryAmount: {
                FamilyPlan: selectedFamily,
                amount: listOfCost[selected],
            },
        };
        props.selectedPlan(DataSelected);
    }, [selected, listOfCost, listOfEnrollCost]);
    const handleClick = (index) => {
        setSelected(index);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, { sx: { width: "100%" } },
            React.createElement(Paper, { sx: { width: "100%", mb: 2 } },
                React.createElement(EnhancedTableToolbar, { title: props.title, planSelected: data[selected], costSelected: listOfCost[selected], enrollFeeSelected: listOfEnrollCost[selected] }),
                React.createElement(TableContainer, { style: { paddingTop: "64px" } },
                    React.createElement(Table, { sx: { minWidth: 750 }, "aria-labelledby": "tableTitle" },
                        React.createElement(TableBody, null, data.map((row, index) => {
                            const isItemSelected = index === selected;
                            const labelId = `enhanced-table-checkbox-${index}`;
                            return (React.createElement(StyledTableRow, { hover: true, onClick: (event) => handleClick(index), role: "radio", "aria-checked": isItemSelected, tabIndex: -1, key: row.planInfo, selected: isItemSelected },
                                React.createElement(TableCell, { padding: "checkbox" },
                                    React.createElement(StyledRadio, { checked: isItemSelected, value: row.planInfo, sx: {
                                            color: "#162242",
                                            "&.Mui-checked": {
                                                color: "#162242",
                                            },
                                        }, name: "radio-buttons", className: "radio-buttons", inputProps: { "aria-label": "A" } })),
                                React.createElement(TableCell, { component: "th", id: labelId, scope: "row", padding: "none" },
                                    "Add ",
                                    React.createElement("b", null, row.planId)),
                                React.createElement(TableCell, { align: "left", style: { width: "10%" } }, props.enrollFeeFlag && (React.createElement(CommonDropDwn, { value: row.enrollmentFeesList, index: index, selectCost: (value, ind) => {
                                        let list = [...listOfEnrollCost];
                                        list[ind] = value;
                                        setListOfEnrollCost(list);
                                    } }))),
                                React.createElement(TableCell, { align: "left", style: { width: "10%" } },
                                    React.createElement(CommonDropFamily, { value: row.categoryAmountList, index: index, selectCost: (value, ind) => {
                                            let list = [...listOfCost];
                                            let amount = row.categoryAmountList.filter((x) => x.category === value)[0].amount;
                                            list[ind] = amount;
                                            setSelectedFamily(value);
                                            setListOfCost(list);
                                        } })),
                                React.createElement(TableCell, { align: "right", style: { width: "10%" } },
                                    React.createElement("span", { className: "cost-per-month", style: {
                                            fontWeight: 650,
                                            fontSize: "25px",
                                        } }, listOfCost[index]),
                                    "/Month"),
                                React.createElement(TableCell, { align: "right", style: { width: "10%" } },
                                    React.createElement("p", { style: { border: "none", fontWeight: 600 } },
                                        React.createElement("span", { className: "details-button" }, "View Details")))));
                        }))))))));
};
const EnhancedTableToolbar = (props) => {
    // const { numSelected } = props;
    const [modalShow, setModalShow] = React.useState(false);
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, null,
            React.createElement(Toolbar, { sx: {
                    pl: { sm: 2 },
                    pr: { xs: 1, sm: 1 },
                    bgcolor: "#162242",
                    position: "fixed",
                    width: "100%",
                    zIndex: 10,
                } },
                React.createElement(Typography, { sx: { display: "flex", flex: "1 1 auto", color: "#fff" }, component: "div" }, props.title),
                React.createElement("div", null,
                    React.createElement(IconButton, null,
                        React.createElement("h3", { style: { color: "#00c389", margin: 0 } },
                            "$",
                            props.costSelected)),
                    React.createElement(IconButton, { style: {
                            backgroundColor: "transparent !important",
                            color: "#4883c6",
                            border: "1px solid #4883c6",
                            height: "30px",
                            fontSize: 15,
                            borderRadius: "5px",
                        }, onClick: () => setModalShow(true) },
                        React.createElement("span", null, "Review Choices"))))),
        React.createElement(ModalPopup, { show: modalShow, onHide: () => setModalShow(false), planSelected: props.planSelected, costSelected: props.costSelected, enrollFeeSelected: props.enrollFeeSelected })));
};
const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 740,
    height: 300,
    bgcolor: "background.paper",
    padding: 0,
    boxShadow: 24,
};
const ModalPopup = (props) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(Modal, { open: props.show, onClose: props.onHide, "aria-labelledby": "modal-modal-title", "aria-describedby": "modal-modal-description" },
            React.createElement(Box, { sx: style },
                React.createElement(Box, null,
                    " ",
                    React.createElement(Toolbar, { sx: {
                            bgcolor: "#e3e3e3",
                        }, className: "modal-header" },
                        React.createElement(Typography, { sx: {
                                flex: "1 1 100%",
                                fontFamily: "Roboto",
                                fontSize: "20px",
                                fontWeight: "500",
                                fontStretch: "normal",
                                fontStyle: "normal",
                                lineHeight: "1",
                                letterSpacing: "0.15px",
                                textAlign: "left",
                                color: "#4f4f4f",
                            }, variant: "h6", id: "tableTitle", component: "div" }, "Review Choices"),
                        React.createElement(IconButton, { onClick: props.onHide },
                            React.createElement(CloseIcon, null)))),
                React.createElement(Box, null,
                    React.createElement(CommonTable, { planSelected: props.planSelected, costSelected: props.costSelected, enrollFeeSelected: props.enrollFeeSelected }))))));
};
